import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { HashRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import WrappedApp from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
    <CssBaseline />
    <WrappedApp />
    </HashRouter>
  </React.StrictMode>
);


